var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{style:(_vm.buttonColors),attrs:{"disabled":_vm.disabledAttr,"type":"button"},on:{"mouseenter":function($event){_vm.assignHoverColor(true)},"mouseleave":function($event){_vm.assignHoverColor(false)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }